import { render, staticRenderFns } from "./JoinChannel.vue?vue&type=template&id=62cacf52&"
import script from "./JoinChannel.vue?vue&type=script&lang=js&"
export * from "./JoinChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports